import ModalAddonDetailed from './ModalAddonDetailed';
export default ModalAddonDetailed;
